/* eslint-disable jira/filename-case */
import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import { wrapPromiseWithFetchInteraction } from '@jira/polaris__lib-analytics/src/wrapPromiseWithFetchInteraction.tsx';
import type { IssueTypesForProjectsResponse } from './IssueTypesForProjectsResponse.types.tsx';
import { getEarlyFetchResponse } from './getEarlyFetchResponse.tsx';
import { getIssueTypesForProjectsUrl } from './getIssueTypesForProjectsUrl.tsx';

type ProjectId = string;

export const performGetIssueTypesForProjects = (
	projectIds: ProjectId[],
): Promise<IssueTypesForProjectsResponse> => {
	if (!projectIds.length) {
		throw new Error('No project ids provided');
	}

	// Try to get from early fetch cache first
	const earlyFetchResponse = getEarlyFetchResponse(projectIds);
	if (earlyFetchResponse) {
		return wrapPromiseWithFetchInteraction(
			earlyFetchResponse,
			'earlyScript/getIssueTypesForProjects',
		).catch(() => {
			// If the cached promise fails, fall back to a regular fetch
			return fetchJson<IssueTypesForProjectsResponse>(getIssueTypesForProjectsUrl(projectIds));
		});
	}

	// Fallback to regular fetch if not in cache
	return fetchJson<IssueTypesForProjectsResponse>(getIssueTypesForProjectsUrl(projectIds));
};
